import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Piece } from 'app/models/piece';
import { PiecesService } from 'app/services/pieces/pieces.service';
import { ProjetsService } from 'app/services/projets/projets.service';
import { AwscontrolService } from 'app/services/aws/awscontrol.service';
import Swal from 'sweetalert2';
import { timeout, catchError } from 'rxjs/operators';
import { of, throwError } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-ajouter-pieces',
  templateUrl: './ajouter-pieces.component.html',
  styleUrls: ['./ajouter-pieces.component.scss']
})
export class AjouterPiecesComponent implements OnInit {
  @ViewChild('descriptionTextarea', { static: false }) descriptionTextarea!: ElementRef;
  @ViewChild('pieceImagesInput', { static: false }) pieceImagesInput!: ElementRef;
  @ViewChild('promoImageInput', { static: false }) promoImageInput!: ElementRef;

  public agenciesProjet: any[] = [];
  public pieces: any;
  public idProjet: any;
  piece: Piece;
  selectedFiles: FileList | null = null;
  allAttch: string[] = [];
  public imageProj!: string;
  agenciesApp: any;
  projet: any;
  projetName: string = '';

  public uploadedImages: string[] = [];
  public uploadedPromoImage: string | null = null;
  public isLoading: boolean = false;
  public isUploading: boolean = false;
  public uploadProgress: number = 0;
  public submitted: boolean = false;

  // Form fields
  public name: string = '';
  public status: string = '';
  public type: string = '';
  public category: string = '';
  public etage: string = '';
  public prixMdt: string = '';
  public surface: string = '';
  public adresse: string = '';
  public description: string = '';
  public nbPieces: number = 0;
  public nbPiscine: number = 0;
  public videoUrl: string = '';   // <-- NEW FIELD

  statusOptions = [
    { value: 'DISPONIBLE', label: 'Disponible' },
    { value: 'EN COURS', label: 'En cours' },
    { value: 'VENDU', label: 'Vendu' },
    { value: 'SOLDE', label: 'Soldé' }
  ];

  constructor(
    private projetService: ProjetsService,
    private piecesService: PiecesService,
    private awsService: AwscontrolService,
    private router: Router,
    private activatedRoute: ActivatedRoute
  ) {
    this.piece = new Piece();
  }

  ngOnInit() {
    localStorage.removeItem('PieceImg');
    this.allAttch = [];
    this.uploadedImages = [];

    this.idProjet = this.activatedRoute.snapshot.paramMap.get('id');
    console.log('ID Projet from route:', this.idProjet);
    this.getData();

    const savedImages = localStorage.getItem('PieceImg');
    if (savedImages) {
      this.allAttch = JSON.parse(savedImages);
      this.uploadedImages = [...this.allAttch];
    }
  }

  getData() {
    this.projetService.getListProjet().subscribe((data: any) => {
      this.agenciesProjet = Array.isArray(data) ? data : [];
      console.log('Liste projets chargée:', this.agenciesProjet);
    });

    if (this.idProjet) {
      this.projetService.getProjet(this.idProjet).subscribe({
        next: (data) => {
          this.projet = data;
          this.projetName = data.name;
          console.log('Projet chargé:', this.projet);
        },
        error: (err) => {
          console.error('Erreur chargement projet:', err);
        }
      });
    }
  }

  validateForm(): boolean {
    return true;
  }

  openImagesSelector(): void {
    if (this.pieceImagesInput && this.pieceImagesInput.nativeElement) {
      this.pieceImagesInput.nativeElement.click();
    }
  }

  onProjectImagesSelected(event: any): void {
    const files = event.target.files;
    if (files && files.length > 0) {
      this.selectedFiles = files;
      this.uploadimg2();
    }
  }

  onPromoImageSelected(event: any): void {
    const file = event.target.files[0];
    if (file) {
      this.uploadPromoImage(file);
    }
  }

  async uploadimg2() {
    if (!this.selectedFiles) return;

    this.isUploading = true;
    this.uploadProgress = 0;

    const totalFiles = this.selectedFiles.length;
    let uploadedCount = 0;

    Swal.fire({
      title: 'Téléchargement en cours...',
      html: `0/${totalFiles} images`,
      allowOutsideClick: false,
      showConfirmButton: false,
      willOpen: () => Swal.showLoading()
    });

    try {
      const files = Array.from(this.selectedFiles);

      for (const file of files) {
        try {
          await this.uploadFileimg2(file);
          uploadedCount++;
          this.uploadProgress = Math.round((uploadedCount / totalFiles) * 100);
          Swal.update({ html: `${uploadedCount}/${totalFiles} images (${this.uploadProgress}%)` });
        } catch (error) {
          console.error(`Erreur upload ${file.name}:`, error);
        }
      }

      Swal.close();
      if (uploadedCount > 0) {
        this.showSuccess(`${uploadedCount} image(s) téléchargée(s) avec succès`);
      }
    } catch (error) {
      console.error('Erreur processus upload:', error);
      Swal.close();
      this.showError('Erreur', 'Une erreur est survenue lors du téléchargement des images');
    } finally {
      this.isUploading = false;
      this.uploadProgress = 0;
      this.selectedFiles = null;
    }
  }

  async uploadFileimg2(file: File) {
    try {
      const folder = 'pieces';
      const response = await this.awsService.uploadFile(file, folder).toPromise();

      if (response.success && response.urls && response.urls.length > 0) {
        const uploadedUrl = response.urls[0];
        this.allAttch.push(uploadedUrl);
        this.uploadedImages.push(uploadedUrl);
        localStorage.setItem('PieceImg', JSON.stringify(this.allAttch));
        return uploadedUrl;
      } else {
        throw new Error(response.error || 'Upload failed');
      }
    } catch (err: any) {
      console.error('Erreur upload image:', err);
      throw err;
    }
  }

  async uploadPromoImage(file: File) {
    this.isUploading = true;
    try {
      Swal.fire({
        title: 'Téléchargement...',
        html: 'Upload de l\'image promotionnelle',
        allowOutsideClick: false,
        showConfirmButton: false,
        willOpen: () => Swal.showLoading()
      });

      const folder = 'pieces-promo';
      const response = await this.awsService.uploadFile(file, folder).toPromise();

      Swal.close();
      if (response.success && response.urls && response.urls.length > 0) {
        this.uploadedPromoImage = response.urls[0];
        this.showSuccess('Image promotionnelle téléchargée');
      } else {
        throw new Error(response.error || 'Upload failed');
      }
    } catch (err: any) {
      console.error('Erreur upload promo:', err);
      Swal.close();
      this.showError('Échec', 'Impossible de télécharger l\'image promotionnelle');
    } finally {
      this.isUploading = false;
    }
  }

  async removeProjectImage(index: number): Promise<void> {
    const imageUrl = this.allAttch[index];
    const result = await Swal.fire({
      title: 'Confirmation',
      text: "Supprimer cette image ?",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#f44336',
      cancelButtonColor: '#6c757d',
      confirmButtonText: 'Oui',
      cancelButtonText: 'Annuler'
    });

    if (result.isConfirmed) {
      try {
        await this.awsService.deleteFile(imageUrl).toPromise();
        console.log('Image supprimée AWS:', imageUrl);
      } catch (error) {
        console.warn('Impossible de supprimer sur AWS:', error);
      }
      this.allAttch.splice(index, 1);
      this.uploadedImages.splice(index, 1);
      localStorage.setItem('PieceImg', JSON.stringify(this.allAttch));
      this.showSuccess('Image supprimée');
    }
  }

  removePromoImage(): void {
    this.uploadedPromoImage = null;
  }

  moveImageUp(index: number): void {
    if (index > 0) {
      [this.allAttch[index], this.allAttch[index - 1]] = [this.allAttch[index - 1], this.allAttch[index]];
      [this.uploadedImages[index], this.uploadedImages[index - 1]] = [this.uploadedImages[index - 1], this.uploadedImages[index]];
      localStorage.setItem('PieceImg', JSON.stringify(this.allAttch));
    }
  }

  moveImageDown(index: number): void {
    if (index < this.allAttch.length - 1) {
      [this.allAttch[index], this.allAttch[index + 1]] = [this.allAttch[index + 1], this.allAttch[index]];
      [this.uploadedImages[index], this.uploadedImages[index + 1]] = [this.uploadedImages[index + 1], this.uploadedImages[index]];
      localStorage.setItem('PieceImg', JSON.stringify(this.allAttch));
    }
  }

  formatText(command: string): void {
    if (this.descriptionTextarea && this.description) {
      const textarea = this.descriptionTextarea.nativeElement;
      const start = textarea.selectionStart;
      const end = textarea.selectionEnd;
      const selectedText = this.description.substring(start, end);

      let formattedText = '';
      switch (command) {
        case 'bold': formattedText = `<strong>${selectedText}</strong>`; break;
        case 'italic': formattedText = `<em>${selectedText}</em>`; break;
        case 'underline': formattedText = `<u>${selectedText}</u>`; break;
        case 'list': formattedText = `<ul><li>${selectedText}</li></ul>`; break;
      }

      const newText = this.description.substring(0, start) + formattedText + this.description.substring(end);
      this.description = newText;

      setTimeout(() => {
        textarea.focus();
        textarea.setSelectionRange(start + formattedText.length, start + formattedText.length);
      }, 0);
    }
  }

  onSubmit() {
    this.submitted = true;

    if (this.isLoading || this.isUploading) {
      this.showWarning('Veuillez patienter', 'Des opérations sont en cours');
      return;
    }

    if (!this.idProjet) {
      this.showError('Erreur', 'ID du projet manquant. Impossible de créer l\'appartement.');
      return;
    }

    this.isLoading = true;

    Swal.fire({
      title: 'Création en cours...',
      html: 'Ajout de l\'appartement, veuillez patienter',
      allowOutsideClick: false,
      showConfirmButton: false,
      willOpen: () => Swal.showLoading()
    });

    const pieceData = {
      name: this.name || 'Sans nom',
      status: this.status || 'DISPONIBLE',
      projetName: this.projetName,
      category: this.category || '',
      type: this.type || '',
      nbPieces: this.nbPieces || 0,
      nbPiscine: this.nbPiscine || 0,
      adresse: this.adresse || '',
      description: this.description || '',
      prixMdt: this.prixMdt || '0',
      surface: this.surface || '0',
      photos: this.allAttch || [],
      videoUrl: this.videoUrl?.trim() ? this.videoUrl : null   // <-- NEW FIELD
    };

    console.log('Données envoyées:', pieceData);
    console.log('ID Projet utilisé:', this.idProjet);

    this.piecesService.createPiece(pieceData, this.idProjet)
      .pipe(
        timeout(30000),
        catchError(err => {
          console.error('Erreur dans l\'appel createPiece:', err);
          return throwError(() => err);
        })
      )
      .subscribe({
        next: (response) => {
          console.log('Réponse du serveur:', response);
          Swal.close();
          this.showSuccessAndRedirect('Appartement créé avec succès!');
        },
        error: (error: any) => {
          Swal.close();
          this.isLoading = false;
          console.error('Erreur détaillée:', error);

          let errorMessage = 'Échec de la création de l\'appartement';

          if (error.name === 'TimeoutError' || (error.message && error.message.includes('timeout'))) {
            errorMessage = 'Le serveur a mis trop de temps à répondre. Veuillez réessayer.';
          } else if (error instanceof HttpErrorResponse) {
            errorMessage = `Erreur ${error.status}: ${error.error?.message || error.message || 'Problème de communication'}`;
          } else if (error.message) {
            errorMessage = error.message;
          }

          this.showError('Erreur', errorMessage);
        },
        complete: () => {
          console.log('Observable createPiece complété');
        }
      });
  }

  showSuccessAndRedirect(message: string): void {
    Swal.fire({
      icon: 'success',
      title: 'Succès!',
      text: message,
      timer: 2000,
      showConfirmButton: false
    }).then(() => {
      localStorage.removeItem('PieceImg');
      this.allAttch = [];
      this.uploadedImages = [];
      this.uploadedPromoImage = null;

      this.resetForm();

      this.navigateBack();
    });
  }

  resetForm(): void {
    this.name = '';
    this.status = '';
    this.type = '';
    this.category = '';
    this.etage = '';
    this.prixMdt = '';
    this.surface = '';
    this.adresse = '';
    this.description = '';
    this.nbPieces = 0;
    this.nbPiscine = 0;
    this.videoUrl = '';   // <-- RESET NEW FIELD
    this.submitted = false;
  }

  navigateBack(): void {
    localStorage.removeItem('PieceImg');
    if (this.idProjet) {
      this.router.navigate(['list-appartement/' + this.idProjet]);
    } else {
      this.router.navigate(['/list-appartement']);
    }
  }

  showSuccess(message: string): void {
    Swal.fire({ icon: 'success', title: message, timer: 1500, showConfirmButton: false });
  }

  showError(title: string, message: string): void {
    Swal.fire({ icon: 'error', title, text: message, confirmButtonColor: '#3f51b5' });
  }

  showWarning(title: string, message: string): void {
    Swal.fire({ icon: 'warning', title, text: message });
  }

  getCategories(): string[] {
    return this.projet?.categoryList || [];
  }
}